import livestream from './livestream';
import modalContent from './modal-content';

export default function(rootElement) {
  if (!rootElement) {
    return;
  }

  livestream(rootElement);
  modalContent();
}
